import React from "react";
import "./legal.css";

import data from "../content/legal/datenschutz.generated.json";

// Datenschutzerklärung. The content is authored as an HTML fragment in
// content/datenschutz.html (e.g. generated via datenschutz-generator.de) and
// compiled into datenschutz.generated.json by scripts/build-legal.js.
const Datenschutz = () => {
    return (
        <div className="legal-page">
            <div
                className="legal-content"
                dangerouslySetInnerHTML={{ __html: data.html }}
            ></div>
        </div>
    );
};

export default Datenschutz;
